"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveEffectiveBookingType = resolveEffectiveBookingType;
exports.routesToTripleseat = routesToTripleseat;
exports.isTripleseatLeadFormEndpoint = isTripleseatLeadFormEndpoint;
exports.resolveTripleseatEndpoint = resolveTripleseatEndpoint;
exports.restaurantUsesTripleseat = restaurantUsesTripleseat;
exports.resolveLargeGroupOptions = resolveLargeGroupOptions;
const TDR_1 = require("../types/TDR");
/**
 * Resolve the effective booking type for a booking, folding in the legacy privateEvents flag.
 * A base (non-override) 'request' at a privateEvents-on venue IS an inquiry: it routes to
 * Tripleseat, so it is classified and routed as one. Override-set types are authoritative and
 * are never upgraded (an override 'request' stays 'request' / admin-approval even with the flag on).
 */
function resolveEffectiveBookingType(args) {
    if (!args.typeFromOverride && args.bookingType === 'request' && args.privateEventsEnabled) {
        return 'inquiry';
    }
    return args.bookingType;
}
/**
 * Does this (already-resolved) booking type route to the Tripleseat / "Sent" path?
 * Purely type-driven: only 'inquiry' routes. The privateEvents flag is applied upstream by
 * resolveEffectiveBookingType, so it is intentionally NOT consulted here.
 */
function routesToTripleseat(bookingType) {
    return bookingType === 'inquiry';
}
/** A usable Tripleseat lead form URL. Override values are unvalidated Firestore data. */
function isTripleseatLeadFormEndpoint(value) {
    return typeof value === 'string' && /^https:\/\/\S+$/.test(value);
}
/**
 * The Tripleseat lead form an inquiry is sent to: the table's own form for this scenario (an
 * override's, already applied by computeEffectiveTable) or else the restaurant's default form.
 */
function resolveTripleseatEndpoint(restaurant, effectiveTable) {
    var _a, _b, _c;
    return (effectiveTable === null || effectiveTable === void 0 ? void 0 : effectiveTable.tripleseatLeadFormEndpoint)
        || ((_c = (_b = (_a = restaurant === null || restaurant === void 0 ? void 0 : restaurant.settings) === null || _a === void 0 ? void 0 : _a.integrations) === null || _b === void 0 ? void 0 : _b.tripleseat) === null || _c === void 0 ? void 0 : _c.lead_form_api_endpoint)
        || undefined;
}
/** True when any booking at this restaurant can be sent to a Tripleseat lead form. */
function restaurantUsesTripleseat(restaurant) {
    var _a, _b, _c, _d;
    return !!((_c = (_b = (_a = restaurant === null || restaurant === void 0 ? void 0 : restaurant.settings) === null || _a === void 0 ? void 0 : _a.integrations) === null || _b === void 0 ? void 0 : _b.tripleseat) === null || _c === void 0 ? void 0 : _c.lead_form_api_endpoint)
        || ((_d = restaurant === null || restaurant === void 0 ? void 0 : restaurant.overrides) !== null && _d !== void 0 ? _d : []).some(override => { var _a; return isTripleseatLeadFormEndpoint((_a = override.values) === null || _a === void 0 ? void 0 : _a.tripleseatLeadFormEndpoint); });
}
/**
 * The LargeGroupOptions for a newly-created or re-resolved large-group reservation, given its
 * already-resolved effective booking type.
 */
function resolveLargeGroupOptions(args) {
    if (routesToTripleseat(args.bookingType)) {
        return {
            notificationEndpoint: args.tripleseatEndpoint,
            largeGroupStatus: TDR_1.TDR.Reservation.LargeGroupStatus.Sent,
        };
    }
    return { largeGroupStatus: TDR_1.TDR.Reservation.LargeGroupStatus.AdminActionRequired };
}
//# sourceMappingURL=largeGroup.js.map